import { render, staticRenderFns } from "./NameSuggestion.vue?vue&type=template&id=69613ebd"
import script from "./NameSuggestion.vue?vue&type=script&lang=js"
export * from "./NameSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports